import { Directive, forwardRef, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, CheckboxRequiredValidator, ValidationErrors } from '@angular/forms';

@Directive({
    selector: 'checkbox[required][ngControl],checkbox[required][ngFormControl],checkbox[required][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => CheckboxRequiredValidatorDirective), multi: true }
    ]
})
export class CheckboxRequiredValidatorDirective extends CheckboxRequiredValidator {
    constructor() {
        super();
        this.required = true;
    }
}


// WEBPACK FOOTER //
// ./app/common/directives/validators/checkboxRequiredValidator.ts